<template>
  <div class="std-background">
    <v-card width="500" class="mx-auto my-3">
      <div class="std-title std-title--no-bg text-center">
        <h2>Dr. Admin login</h2>
      </div>
      <div class="std__content" :class="{'ma-2 pa-3': $vuetify.breakpoint.smAndDown}">
        <!-- START FORM -->
        <v-form v-model="valid">

          <!-- START EMAIL FIELD -->
          <v-text-field
            class="pb-3"
            outlined dense color="primaryLight"
            type="email" v-model="email" label="Enter admin email" :rules="emailRules"
            required>
          </v-text-field>

          <!-- START PASSWORD FIELD -->
          <v-text-field
            outlined dense color="primary"
            v-model="password" :rules="passwordRules" label="Enter admin password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            required>
          </v-text-field>
        </v-form>
        <!-- END FORM -->

        <p v-if="error.isError" class="red--text py-3">
          {{error.message}}
        </p>
        <p>Please contact synapsebn support team at <a href="mailto:synapsebn@gmail.com">synapsebn@gmail.com</a> in case you have forgotten your password.</p>
        <div class="text-center mt-3 mb-10">
          <v-btn block depressed color="primaryLight" class="white--text"
            :loading="loading" :disabled="loading || !valid" @click="login()">
            Login
            <template v-slot:loader>
              <span>Processing...</span>
            </template>
          </v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        valid: false,
        loading: false,
        email: '',
        emailRules: [
          email => !!email || 'Please enter your email here',
          email => (email && /.+@.+/.test(email)) || 'Please check email format (this@example.com)'
        ],
        password: '',
        showPassword: false,
        passwordRules: [
          password => !!password || 'Please enter a password here'
        ],
        error: {}
      }
    },
    methods: {
      login() {
        this.loading = true
        this.error = { message: '', isError: false }
        this.$store.dispatch('login', {
          email: this.email,
          password: this.password
        }).then(res => {
          if (res && res.isError) {
            this.loading = false
            this.error = { message: res.message, isError: res.isError}
          } else this.$router.push('/dashboard')
        })
      }
    }
  }
</script>